import React from "react";
import Calendar from 'react-calendar'
import { useI18n } from '../utilities/i18n'

function CustomCalendar(props) {
  const { lang } = useI18n();
  const raw = props.currentDate;
  const value = raw instanceof Date && !Number.isNaN(raw.getTime()) ? raw : null;

  return (
    <div ref={props.ref}>
    <Calendar
      locale={lang === 'en' ? 'en-US' : 'ru-RU'}
      value={value}
      onChange={props.changeDate}/>
    </div>
  );
}

export default CustomCalendar;